(() => {
  const root = document.querySelector('[data-ff-editorial]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const revealItems = root.querySelectorAll('.ffx-reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  const video = root.querySelector('[data-ffx-video]');
  const toggle = root.querySelector('[data-ffx-video-toggle]');
  const state = root.querySelector('[data-ffx-video-state]');
  if (video && toggle && state) {
    toggle.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
        toggle.classList.remove('is-paused');
        toggle.setAttribute('aria-label', 'Pausar video');
        state.textContent = 'PAUSE';
      } else {
        video.pause();
        toggle.classList.add('is-paused');
        toggle.setAttribute('aria-label', 'Reproducir video');
        state.textContent = 'PLAY';
      }
    });
  }

  const urgency = root.querySelector('[data-ffx-urgency]');
  if (urgency) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Mexico_City',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date()).reduce((acc, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});
    const weekday = parts.weekday;
    const hour = Number(parts.hour || 0);
    const businessDay = !['Sat', 'Sun'].includes(weekday);
    urgency.textContent = businessDay && hour < 12
      ? 'COMPRA ANTES DE LAS 12:00 H · PROCESAMOS HOY · ENVÍO GRATIS DESDE $499'
      : 'ASEGURA TU PEDIDO HOY · PROCESAMOS EL SIGUIENTE DÍA HÁBIL · ENVÍO GRATIS DESDE $499';
  }

  const stories = root.querySelector('[data-ffx-stories]');
  const storyCards = stories ? Array.from(stories.querySelectorAll('[data-ffx-story]')) : [];
  const storiesPrev = root.querySelector('[data-ffx-stories-prev]');
  const storiesNext = root.querySelector('[data-ffx-stories-next]');
  const storiesCount = root.querySelector('[data-ffx-stories-count]');

  if (stories && storyCards.length) {
    let activeStory = 0;
    let scrollFrame = 0;

    const pauseStory = (card) => {
      const media = card.querySelector('[data-ffx-story-video]');
      if (media && !media.paused) media.pause();
      card.classList.remove('is-playing');
      const control = card.querySelector('[data-ffx-story-toggle]');
      if (control) {
        control.setAttribute('aria-label', control.dataset.playLabel || 'Reproducir video');
        control.setAttribute('aria-pressed', 'false');
      }
    };

    const updateStories = (index) => {
      activeStory = Math.max(0, Math.min(index, storyCards.length - 1));
      if (storiesCount) {
        storiesCount.textContent = `${String(activeStory + 1).padStart(2, '0')} / ${String(storyCards.length).padStart(2, '0')}`;
      }
      const maxScroll = Math.max(0, stories.scrollWidth - stories.clientWidth);
      if (storiesPrev) storiesPrev.disabled = stories.scrollLeft <= 2;
      if (storiesNext) storiesNext.disabled = stories.scrollLeft >= maxScroll - 2;
    };

    const scrollToStory = (index) => {
      const target = storyCards[Math.max(0, Math.min(index, storyCards.length - 1))];
      if (!target) return;
      stories.scrollTo({
        left: target.offsetLeft - stories.offsetLeft,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      updateStories(index);
    };

    storyCards.forEach((card, index) => {
      const media = card.querySelector('[data-ffx-story-video]');
      const control = card.querySelector('[data-ffx-story-toggle]');
      if (!media || !control) return;

      const toggleStory = () => {
        if (media.paused) {
          storyCards.forEach((other) => { if (other !== card) pauseStory(other); });
          media.play().then(() => {
            card.classList.add('is-playing');
            control.setAttribute('aria-label', control.dataset.pauseLabel || 'Pausar video');
            control.setAttribute('aria-pressed', 'true');
            updateStories(index);
          }).catch(() => {});
        } else {
          pauseStory(card);
        }
      };

      control.addEventListener('click', toggleStory);
      media.addEventListener('click', toggleStory);
      media.addEventListener('ended', () => pauseStory(card));
      media.addEventListener('pause', () => {
        card.classList.remove('is-playing');
        control.setAttribute('aria-label', control.dataset.playLabel || 'Reproducir video');
        control.setAttribute('aria-pressed', 'false');
      });
    });

    if ('IntersectionObserver' in window) {
      const storyObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio < 0.2) pauseStory(entry.target);
        });
      }, { threshold: [0, 0.2, 0.8] });
      storyCards.forEach((card) => storyObserver.observe(card));
    }

    if (storiesPrev) storiesPrev.addEventListener('click', () => scrollToStory(activeStory - 1));
    if (storiesNext) storiesNext.addEventListener('click', () => scrollToStory(activeStory + 1));

    stories.addEventListener('scroll', () => {
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        const anchor = stories.scrollLeft + stories.offsetLeft;
        const closest = storyCards.reduce((best, card, index) => {
          const distance = Math.abs(card.offsetLeft - anchor);
          return distance < best.distance ? { index, distance } : best;
        }, { index: 0, distance: Infinity });
        updateStories(closest.index);
      });
    }, { passive: true });

    updateStories(0);
  }

  const installMobileOverlayStyles = () => {
    const popConvertHost = document.querySelector('#pop-convert-app');
    const shadowRoot = popConvertHost && popConvertHost.shadowRoot;
    if (!shadowRoot) return false;
    if (shadowRoot.querySelector('[data-ffx-mobile-overlay-style]')) return true;

    const style = document.createElement('style');
    style.setAttribute('data-ffx-mobile-overlay-style', '');
    style.textContent = `
      @media (max-width: 767px) {
        .pc-buttons-trigger-wrapper .pc-floating-button[class*="mobile-"] {
          left: 14px !important;
          right: auto !important;
          bottom: calc(14px + env(safe-area-inset-bottom, 0px)) !important;
          transform: none !important;
          max-width: calc(100vw - 92px) !important;
          padding: .62em .9em !important;
          border-radius: 10px !important;
          box-sizing: border-box !important;
          line-height: 1.15 !important;
        }
      }
    `;
    shadowRoot.appendChild(style);
    return true;
  };

  if (!installMobileOverlayStyles()) {
    let overlayAttempts = 0;
    const overlayTimer = window.setInterval(() => {
      overlayAttempts += 1;
      if (installMobileOverlayStyles() || overlayAttempts >= 40) {
        window.clearInterval(overlayTimer);
      }
    }, 250);
  }
})();
